// extracted by mini-css-extract-plugin
module.exports = {"exam_rules_content_wrapper":"Content_exam_rules_content_wrapper__1jU8V"};